import React from 'react';
import { Job } from '../../types/job';
import { QuoteJob } from '../../types/quote';
import { getJobPublishedInfo } from '../../utils/jobUtils';
import { TFunction } from 'i18next';

interface JobPublishedDateProps {
  job: Job | QuoteJob;
  t: TFunction;
  language: string;
  className?: string;
}

const JobPublishedDate: React.FC<JobPublishedDateProps> = ({
  job,
  t,
  language,
  className = '',
}) => {
  const { publishedAtLabel, publishedDate } = getJobPublishedInfo(job, t, language);

  if (!publishedDate) {
    return null;
  }

  return (
    <div className={`flex flex-col text-secondary ${className}`}>
      <span className="text-xs">{publishedAtLabel}</span>
      <span className=" text-xs font-bold">{publishedDate}</span>
    </div>
  );
};

export default JobPublishedDate;
